export const includeTexts = [
        'create_request', 
        'create_offer', 
        'offer_detail',
        'offer_user',
        'offer_overview',
        'offer_success',
        "adds",
        "chat",
        "withdraw",
        "service",
        "marketplace",
        "profile"
    ] 